const SelectField = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  error,
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label}
        {required && <span> *</span>}
      </label>

      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className={error ? "input-error" : ""}
      >
        <option value="">Select {label.toLowerCase()}</option>

        {options.map((option, index) => {
          const isObject = typeof option === "object";

          const optionValue = isObject ? option.value : option;
          const optionLabel = isObject ? option.label : option;

          return (
            <option key={optionValue ?? index} value={optionValue}>
              {optionLabel}
            </option>
          );
        })}
      </select>

      {error && <small className="error-message">{error}</small>}
    </div>
  );
};

export default SelectField;
